import template from './share-buttons.tpl';
import './share-buttons.css';

const ShareButtons = DomClass(template, function ShareButtons() {
	var _t = this;

	var inner_object;

	this.getObject = function() {
		var rv = _t.object || _t;

		if (inner_object) {
			rv.url = inner_object.url;
		} else if (!rv.url) {	
			rv.url = location.href;
		}

		if (!rv.title) {
			rv.title = document.title;
		}

		if (!rv.description) {
			var meta = document.querySelector("meta[name=\'description\']");
			if (meta) {
				rv.text = meta.getAttribute("content");
			}
		}

		if (!rv.text) {
			rv.text = rv.description;
		}

		if (!rv.image) {
			rv.image = location.origin + "/bacteria-512x512.png";
		}

		if (typeof(rv.proxy) == 'undefined') {
			rv.proxy = true;
		}

		inner_object = rv;

		return rv;
	};

	this.track = function(channel) {
		// this needs to be re-worked for analytics 4.
		// this is currently a no-op (i think).
		var o = _t.getObject();
		window._gaq = window._gaq || [];
		_gaq.push(['_trackEvent', 'Share', channel, o['url'], null])
	};

	var fb_share = function(url) {
		_t.track('Facebook');
		var o = _t.getObject();

		var app_id = "1210357722670229";

		var tags = (o.tags || [title]).map(t => (
			"#" + t.toLowerCase().replaceAll(' ', '')
		));

		var og_url =
			"https://www.ratemydisease.com/api/og"
			+ "?url=" + encodeURIComponent(url || o['url'])
			+ "&title=" + encodeURIComponent(o['title'])
			+ "&description=" + encodeURIComponent(o['description'])
			+ "&image=" + encodeURIComponent(o['image'])
		;

		console.log('og_url', JSON.stringify(og_url));

		var url = "https://www.facebook.com/sharer.php"
			+ "?u=" + encodeURIComponent(og_url)
			+ "&t=" + encodeURIComponent(o['title'])
			+ `&app_id=${app_id}`
			+ "&quote=" + encodeURIComponent(o['text'] || '')
		;

		window.open(url, 'facebook_share');
		return false;
	};

	var twitter_share = function(url) {
		_t.track('Twitter');
		var o = _t.getObject();
		var title = "#" + (o['title'] || 'ratemydisease');
		var tags = (o.tags || [title]).map(t => (
			"#" + t.toLowerCase().replaceAll(' ', '')
		));
		var	url = "https://twitter.com/intent/tweet?"
			+ "text=" + encodeURIComponent(
				(o['text'] || '').substr(0, 150) + '...'
				+ ' ' + tags.join(' ')
				+ ' ' + (url || o['url'])
			)
		;
		window.open(url, 'twitter_share');
		return false;
	};

	var email_share = function(url) {
		_t.track('Email');
		var o = _t.getObject();
		var url = "mailto:?to=&"
			+ "subject=" + encodeURIComponent(o['title'] || 'check out this disease')
			+ "&body=" + encodeURIComponent(o['text'] || '')
			 	+ encodeURIComponent("\n\n")
				+ encodeURIComponent(url || o['url'])
		;
		window.open(url, 'email_share');
		return false;
	};

	this.email_link.onclick = function(evt) {
		evt.stopPropagation();
		if (_t.preshare) {
			_t.preshare(email_share);
		} else {
			email_share();
		}
	};

	this.twitter_link.onclick = function(evt) {
		evt.stopPropagation();
		if (_t.preshare) {
			_t.preshare(twitter_share);
		} else {
			twitter_share();
		}
	};

	this.fb_link.onclick = function(evt) {
		evt.stopPropagation();
		if (_t.preshare) { 
			_t.preshare(fb_share);
		} else {
			fb_share();
		}
	};

});

export default ShareButtons;
